import React from 'react';
import { Box, Checkbox } from '@chakra-ui/react';

interface SelectItemCheckboxProps {
  onClick: (event: React.ChangeEvent<HTMLElement>) => void;
  value: string;
  isChecked: boolean;
  dark: boolean;
}

const SelectItemCheckbox: React.FC<SelectItemCheckboxProps> = ({
  onClick,
  children,
  value,
  isChecked,
  dark,
}) => (
  <Box
    px={4}
    py={1}
    borderRadius="lg"
    _hover={{
      bg: dark ? 'gray.900' : 'gray.200',
    }}
  >
    <Checkbox
      size="md"
      borderColor="gray.500"
      colorScheme="yellow"
      onChange={onClick}
      value={value}
      w="100%"
      isChecked={isChecked}
    >
      {children}
    </Checkbox>
  </Box>
);

export default SelectItemCheckbox;
